import { Box, Button, CircularProgress, Typography, Card, Divider, Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { UserService } from "../services/user.service";
import { ProductRequest as ProductRequestType } from "../models/product.models";

const BlockchainDetailsPage = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [request, setRequest] = useState<any>(null);
  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    const fetchRequest = async () => {
      setIsLoading(true);
      const res: ProductRequestType | undefined = await UserService.getUserProductRequests(1, 100, 'Blockchain Analysis');
      if (res && res.data) {
        const foundRequest = res.data.find(req => req.id === id);
        if (foundRequest) {
          setRequest(foundRequest);
          console.log('Fetched blockchain request details:', foundRequest);
        }
      }
      setIsLoading(false);
    };
    fetchRequest();
  }, [id]);

  if (isLoading) {
    return <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "60vh" }}><CircularProgress /></Box>;
  }

  if (!request) {
    return (
      <Box sx={{ padding: "24px", background: "white", minHeight: "60vh" }}>
        <Typography variant="h4" sx={{ mb: 2 }}>Request Not Found</Typography>
        <Button variant="contained" color="primary" onClick={() => navigate('/blockchain-analysis/status')}>
          Back to Status
        </Button>
      </Box>
    );
  }

  return (
    <Box sx={{ padding: "24px", background: "white", minHeight: "60vh" }}>
      <Typography variant="h4" sx={{ mb: 2 }}>
        Blockchain Analysis Request Details
      </Typography>
      <Card sx={{ p: 3, mb: 3 }}>
        <Typography variant="h6" sx={{ mb: 2 }}>General</Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}><strong>ID:</strong> {request.id}</Grid>
          <Grid item xs={12} sm={6}><strong>Status:</strong> {request.status}</Grid>
          <Grid item xs={12} sm={6}><strong>Created At:</strong> {new Date(request.Created_Time).toLocaleString()}</Grid>
          <Grid item xs={12} sm={6}><strong>Contract Signed:</strong> {request.contractSigned ? 'Yes' : 'No'}</Grid>
        </Grid>
        <Divider sx={{ my: 2 }} />
        <Typography variant="h6" sx={{ mb: 2 }}>Request Inputs</Typography>
        <Grid container spacing={2}>
          {request.requestDetails &&
            Object.entries(request.requestDetails).map(([key, value]) => {
              let label = key.replace(/^blockchainAnalysis|^blockchain_analysis/i, "");
              label = label.replace(/^[_\s]+/, "");
              label = label
                .replace(/([A-Z])/g, " $1")
                .replace(/_/g, " ")
                .replace(/^./, (str) => str.toUpperCase())
                .trim();
              return (
                <Grid item xs={12} sm={6} key={key}>
                  <strong>{label}:</strong> {String(value)}
                </Grid>
              );
            })}
        </Grid>
        <Divider sx={{ my: 2 }} />
        <Typography variant="h6" sx={{ mb: 2 }}>Payment</Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}><strong>Amount Due:</strong> {request.leftToPay != null ? `${request.leftToPay}$` : '-'}</Grid>
          <Grid item xs={12} sm={6}><strong>Paid:</strong> {request.paid != null ? `${request.paid}$` : '-'}</Grid>
        </Grid>
      </Card>
      <Box sx={{ display: 'flex', gap: 2 }}>
        <Button variant="contained" color="primary" onClick={() => navigate('/blockchain-analysis/status')}>
          Back to Status
        </Button>
        <Button variant="outlined" color="primary" onClick={() => navigate('/blockchain-analysis/new')}>
          New Request
        </Button>
      </Box>
    </Box>
  );
};

export default BlockchainDetailsPage; 